export default __webpack_public_path__ + "static/media/facebook.8ad8268e.svg";